import { CheckIcon } from "@heroicons/react/outline";
import { findBrandByVendor, findBrandByVendorId } from "@/utils/data/brands";

interface ProductDetailsProps {
  isAuthenticated: boolean;
  quantityOnHand: number;
  prefVendor: string;
  prefVendorId?: number | null;
}

export const ProductDetails = ({ isAuthenticated, quantityOnHand, prefVendor, prefVendorId }: ProductDetailsProps) => {
  // Prefer the stable vendor RecordID; fall back to the vendor name, then the raw name.
  const brand = findBrandByVendorId(prefVendorId) || findBrandByVendor(prefVendor);
  return (
  <section aria-labelledby="details-heading" className="mt-12">
    <h2 id="details-heading" className="sr-only">Additional details</h2>
    <div className="mt-8 border-t border-gray-200 pt-8">
      {isAuthenticated && (
        <div className="flex items-center mb-6">
          <CheckIcon className="w-5 h-5 text-green-500" aria-hidden="true" />
          <p className="ml-2 text-sm text-gray-500">
            {quantityOnHand > 0
              ? "In stock and ready to ship"
              : "In stock with constrained inventory; units allocated on a first-come-first-served basis for Dealers and Distributors."}
          </p>
        </div>
      )}
      <h2 className="text-sm text-gray-600">
        Made with care by{" "}
        <span className="font-medium text-gray-900">
          {brand?.displayName || prefVendor}
        </span>
      </h2>
    </div>
  </section>
  );
};